import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { PIFormSection } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { CustomSelect, selectTypes } from 'src/consumer/components/helperComponents'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { GRID_CONFIG } from '../utils/patientFormConfig'
import { CheckboxFormField, FormField } from './FormField'
import PatientAlternativeMobiles from './PatientAlternativeMobiles'
import PatientAttendants from './PatientAttendants'
import PatientCommunicationToPref from './PatientCommunicationToPref'

export const PatientMoreDetails = ({
  patientDetails,
  editMode = true,
  formHook,
  validationHook,
  visibilityHook,
  makeAnonymousPatient,
  dontUseMoreDetailsAccordian = false
}) => {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)

  const MoreDetailsContent = () => (
    <PIFormSection container spacing={2}>
          {/* Email in More Details */}
          {visibilityHook.shouldShowEmailInMoreDetails && (
            <FormField
              label="Email"
              value={patientDetails?.email}
              onChange={formHook.handleEmailChange}
              disabled={!editMode}
              gridConfig={GRID_CONFIG}
              validationError={
                validationHook.getFieldValidation('email').showError ? 'Required' : null
              }
            />
          )}

          {/* Attendants */}
          {visibilityHook.isFieldVisible('attendants') && (
            <PatientAttendants
              attendants={patientDetails?.attendants}
              onAdd={formHook.addAttendant}
              onUpdate={formHook.updateAttendant}
              onRemove={formHook.removeAttendant}
              editMode={editMode}
              validationHook={validationHook}
            />
          )}

          {/* Communication to Attendant */}
          {visibilityHook.isFieldVisible('communicationToAttendant') &&
            Array.isArray(patientDetails?.attendants) &&
            patientDetails?.attendants?.length > 0 && (
              <CheckboxFormField
                label="Communication to Attendant"
                checked={!!patientDetails?.communicationToAttendant}
                onChange={formHook.handleCommunicationToAttendantChange}
                disabled={!editMode}
                checkboxProps={{ size: 'small' }}
                gridConfig={GRID_CONFIG}
                className="flex-column"
              />
            )}

          {/* Language */}
          {visibilityHook.isFieldVisible('language') && (
            <FormField label="Language" gridConfig={GRID_CONFIG}>
              <CustomSelect
                isDisabled={!editMode}
                value={patientDetails?.defaultCommunicationLanguage}
                id="defaultCommunicationLanguage"
                options={unSecureSetupData?.appLanguages}
                getOptionValue={(optn) => optn?.id}
                menuPlacement="auto"
                getOptionLabel={(optn) =>
                  `${optn?.language} ${optn?.id !== 'en' ? `(${optn?.localLanguageName})` : ''}`
                }
                selectType={selectTypes.string}
                onChangeEvent={formHook.handleLanguageChange}
              />
            </FormField>
          )}

          {/* City */}
          {visibilityHook.isFieldVisible('city') && (
            <FormField
              label="City"
              value={patientDetails?.city}
              onChange={formHook.handleCityChange}
              disabled={!editMode}
              gridConfig={GRID_CONFIG}
            />
          )}

          {/* Pincode */}
          {visibilityHook.isFieldVisible('pincode') && (
            <FormField
              label="Pincode"
              type="number"
              value={patientDetails?.pincode}
              onChange={formHook.handlePincodeChange}
              disabled={!editMode}
              gridConfig={GRID_CONFIG}
            />
          )}

          {/* Note */}
          {visibilityHook.isFieldVisible('note') && (
            <FormField
              label="Note"
              value={patientDetails?.note}
              onChange={formHook.handleNoteChange}
              disabled={!editMode}
              gridConfig={GRID_CONFIG}
            />
          )}

          {/* Alternative Mobile Numbers */}
          {visibilityHook.isFieldVisible('alternativeMobiles') && (
            <PatientAlternativeMobiles
              alternativeMobiles={patientDetails?.altMobiles}
              onAdd={formHook.addAlternativeMobile}
              onUpdate={formHook.updateAlternativeMobile}
              onRemove={formHook.removeAlternativeMobile}
              editMode={editMode}
              validationHook={validationHook}
            />
          )}

          {/* Referred By */}
          {visibilityHook.isFieldVisible('referredBy') && (
            <FormField
              label="Referred By"
              value={patientDetails?.referredBy}
              onChange={formHook.handleReferredByChange}
              disabled={!editMode}
              gridConfig={GRID_CONFIG}
            />
          )}

          {/* Communication Preferences */}
          {visibilityHook.isFieldVisible('communicationToPref') && (
            <PatientCommunicationToPref
              communicationToPref={patientDetails?.communicationToPref}
              onPreferenceChange={formHook.handleCommunicationToPrefChange}
              onAddReceiver={formHook.addCommunicationReceiver}
              onUpdateReceiver={formHook.updateCommunicationReceiver}
              onRemoveReceiver={formHook.removeCommunicationReceiver}
              editMode={editMode}
              validationHook={validationHook}
            />
          )}
    </PIFormSection>
  )

  if (dontUseMoreDetailsAccordian) {
    return <MoreDetailsContent />
  }

  return (
    <Accordion disableGutters elevation={0} defaultExpanded={!editMode}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography component="span">More Details</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <MoreDetailsContent />
      </AccordionDetails>
    </Accordion>
  )
}

export default PatientMoreDetails
